module.exports = {
    title: "Company Type",
    crud: {
        create: "Create Company Type",
        edit: "Edit Company Type",
        view: "View Company Type",
    },
    table: {
        title: "Title",
        isActive: 'Active',
        type: 'Type',
        industry:"Industry"
    },
    form: {
        title: "Title",
        isActive: 'Active',
        type: 'Type',
        industry: 'Industry',
    },
    validation: {
        required: {
            title: 'Title is required',
            type: 'Type is required',
            industry: 'Industry is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
